'use client'

import * as React from 'react'
import { Section } from '../layout/Section'
import { Container } from '../layout/Container'
import { FadeIn } from '../motion/FadeIn'

interface AboutPageProps {
  appName: string
  heading?: string
  story: string | React.ReactNode
  companySection?: {
    heading: string
    description: string
  }
  email?: string
}

export function AboutPage({
  appName,
  heading,
  story,
  companySection = {
    heading: 'Built by Van Moose',
    description: 'We\'re a small team based in Amsterdam, Netherlands, focused on building simple, useful software that respects your time and privacy.',
  },
  email,
}: AboutPageProps) {
  const defaultHeading = `About ${appName}`

  return (
    <Section className="min-h-[60vh]">
      <Container size="md">
        <FadeIn>
          <h1 className="headline-lg mb-6">{heading || defaultHeading}</h1>
        </FadeIn>

        <div className="prose prose-lg text-[var(--landing-text-secondary)] space-y-6">
          <FadeIn delay={0.1}>
            {typeof story === 'string' ? <p>{story}</p> : story}
          </FadeIn>

          {companySection && (
            <>
              <FadeIn delay={0.2}>
                <h2 className="text-2xl font-semibold text-[var(--landing-text-primary)] mt-12 mb-4">
                  {companySection.heading}
                </h2>
              </FadeIn>
              <FadeIn delay={0.3}>
                <p>{companySection.description}</p>
              </FadeIn>
            </>
          )}

          {email && (
            <FadeIn delay={0.4}>
              <p>
                Have questions or feedback? We&apos;d love to hear from you at{' '}
                <a href={`mailto:${email}`} className="text-[var(--accent)] hover:underline">
                  {email}
                </a>
              </p>
            </FadeIn>
          )}
        </div>
      </Container>
    </Section>
  )
}
